import { render, staticRenderFns } from "./WebhooksFormTemplate.vue?vue&type=template&id=452fad7e&"
import script from "./WebhooksFormTemplate.vue?vue&type=script&lang=js&"
export * from "./WebhooksFormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksFormTemplate.vue?vue&type=style&index=0&id=452fad7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports